import { useState } from 'react';
import { Box, Tabs, Tab, IconButton, Tooltip, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import TabAsesor from '../components/TabAsesor';
import TabJefatura from '../components/TabJefatura';
import TabLider from '../components/TabLider';
import DrawerParametrizacion from '../components/DrawerParametrizacion';
import { PeriodoProvider } from '../context/PeriodoContext';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export default function ReporteComisionesPage() {
  const [tabValue, setTabValue] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleToggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <PeriodoProvider>
      <Box sx={{ width: '100%' }}>
        {/* Título principal */}
        <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600 }}>
            📑 Reporte de Comisiones
          </Typography>
          <Tooltip title="Parametrización de comisiones">
            <IconButton
              color="primary"
              onClick={handleToggleDrawer}
              sx={{
                bgcolor: drawerOpen ? 'primary.light' : 'transparent',
                '&:hover': { bgcolor: 'primary.light' }
              }}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </Box>

        {/* Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Asesor/Supervisor" id="tab-0" aria-controls="tabpanel-0" />
            <Tab label="Líder" id="tab-1" aria-controls="tabpanel-1" />
            <Tab label="Jefatura" id="tab-2" aria-controls="tabpanel-2" />
          </Tabs>
        </Box>

        {/* Tab Panels */}
        <TabPanel value={tabValue} index={0}>
          <TabAsesor onOpenParametrizacion={handleToggleDrawer} />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
         <TabLider onOpenParametrizacion={handleToggleDrawer} />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <TabJefatura onOpenParametrizacion={handleToggleDrawer} />
        </TabPanel>

        {/* Drawer de Parametrización */}
        <DrawerParametrizacion
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        />
      </Box>
    </PeriodoProvider>
  );
}
